import { ChangeEvent, FormEvent, useState } from "react";
import { MyndaType } from "shared";
import { CreateEmployerJob } from "types/employer.interface";

interface Props {
  onNext: () => void;
  onBack: () => void;
  input: CreateEmployerJob;
  onChange: (
    e:
      | ChangeEvent<HTMLInputElement>
      | ChangeEvent<HTMLSelectElement>
      | ChangeEvent<HTMLTextAreaElement>
      | {
          target: {
            name: string;
            value: string | number;
          };
        }
  ) => void;
  onChangeByNameValue: (name: keyof CreateEmployerJob, value: any) => void;
}

export default function Budget({
  onNext,
  input,
  onChange,
  onChangeByNameValue,
  onBack,
}: Props) {
  const [message, setMessage] = useState("");

  const submitHandler = async (e: FormEvent) => {
    e.preventDefault();

    if (Number(input.minSalary || 0) > Number(input.maxSalary || 0)) {
      setMessage("Minimum budget should not be greater than maximum budget");
      return;
    }
    onNext();
  };

  return (
    <div className="w-full ">
      <form onSubmit={submitHandler} className=" flex flex-col gap-8 ">
        <div className="flex flex-col gap-1">
          <h2 className=" font-body font-medium text-lg lg:text-xl leading-5 text-body">
            Pay range
          </h2>
        </div>

        {input.jobType === MyndaType.LeaveOut ? (
          <>
            <div className="flex flex-col gap-2">
              <label htmlFor="workingHrs">
                How many hours per day do you want the Mynda to work?
              </label>

              <input
                placeholder="Hrs per day"
                id="workingHrs"
                name="workingHrs"
                value={input.workingHrs}
                onChange={onChange}
                required
                pattern="[0-9]*"
                title="Enter numbers only"
                type="number"
                inputMode="numeric"
                className="border bg-input border-gray-300 rounded-sm px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="flex flex-col gap-2">
              <label htmlFor="minSalry">What is your budget per hour?</label>
              <div className="flex flex-col md:flex-row items-center gap-4">
                <input
                  placeholder="Minimum budget per hr"
                  id="minSalary"
                  name="minSalary"
                  // @ts-ignore
                  value={input.minSalary!}
                  onChange={onChange}
                  required
                  className="border bg-input border-gray-300 rounded-sm px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  placeholder="Maximum budget per hr"
                  id="maxSalary"
                  name="maxSalary"
                  // @ts-ignore
                  value={input.maxSalary!}
                  onChange={onChange}
                  required
                  className="border bg-input border-gray-300 rounded-sm px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </>
        ) : (
          <div className="flex flex-col gap-2">
            <label htmlFor="workingHrs">What is your budget per month?</label>
            <div className="flex flex-col md:flex-row items-center gap-4">
              <input
                placeholder="Minimum budget"
                id="minSalary"
                name="minSalary"
                // @ts-ignore
                value={input.minSalary!}
                onChange={onChange}
                required
                className="border bg-input border-gray-300 rounded-sm px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                placeholder="Maximum budget"
                id="maxSalary"
                name="maxSalary"
                // @ts-ignore
                value={input.maxSalary!}
                onChange={onChange}
                required
                className="border bg-input border-gray-300 rounded-sm px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        )}

        {message && <span>{message}</span>}
        <div className="flex items-center gap-4 mt-8">
          <button onClick={onBack} className="px-10">
            Back
          </button>
          <button className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 transition-colors">
            Next
          </button>
        </div>
      </form>
    </div>
  );
}
